import { CustomerState } from "./types";
import{ CustomerSchema } from "@/models/customer_schema";

export const setCustomer = (state: CustomerState, value: CustomerSchema[]) => {
  state.customers = value;
};

export const setSelected = (state: CustomerState, value: CustomerSchema) => {
  state.selected = value;
};

